<template>
  <BaseDialog
    :is-open="isOpen"
    @close="$emit('close')"
    type="basic"
    :title="$t('dialog.retractDialog.title')"
  >
    <div
      class="bg-secondary-container text-on-secondary-container rounded-medium mb-2 flex items-center gap-3 p-4"
    >
      <BaseIcon>undo</BaseIcon>
      <p class="text-body-medium">
        {{ $t('dialog.retractDialog.description', { firstName: coacheeName }) }}
      </p>
    </div>
    <template #confirm>
      <BaseTextButton color="filled" @click="$emit('retractDialog')" size="M">{{
        $t('dialog.retract')
      }}</BaseTextButton>
    </template>
    <template #dismiss>
      <BaseTextButton @click="$emit('close')" size="M">{{ $t('common.cancel') }}</BaseTextButton>
    </template>
  </BaseDialog>
</template>

<script setup lang="ts">
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'

  interface Props {
    isOpen: boolean
    coacheeName: string
  }

  defineProps<Props>()

  defineEmits<{
    (e: 'close'): void
    (e: 'retractDialog'): void
  }>()
</script>
